/**
 * Tracks whether cold-boot public config came from the API or bundled defaults.
 * Used to surface a single non-blocking "running on defaults" alert when the API
 * was unreachable — not when the API returned an empty-but-valid payload.
 */

export type BootConfigSource = 'api' | 'cache' | 'bundled-defaults';

let bootConfigSource: BootConfigSource = 'api';
let bootConfigUnreachable = false;

/** Mark that a public bootstrap call could not reach the API. */
export function markBootConfigUnreachable(reason: string) {
  bootConfigUnreachable = true;
  bootConfigSource = 'bundled-defaults';
  console.warn(`[settings] Boot config source set to bundled-defaults (${reason}).`);
}

/** Mark that authenticated settings were applied from IndexedDB cache. */
export function markBootConfigFromCache() {
  if (!bootConfigUnreachable) {
    bootConfigSource = 'cache';
  }
}

/** Mark that API settings were applied successfully. */
export function markBootConfigFromApi() {
  if (!bootConfigUnreachable) {
    bootConfigSource = 'api';
  }
}

export function getBootConfigSource(): BootConfigSource {
  return bootConfigSource;
}

/** True when public bootstrap could not reach the API (alert should show). */
export function shouldAlertBootConfigDefaults(): boolean {
  return bootConfigUnreachable;
}

/** Test helper. */
export function resetBootConfigSourceState() {
  bootConfigSource = 'api';
  bootConfigUnreachable = false;
}
